import type { Node, Position } from '@xyflow/react';
import type { LineageFlowNode } from '../EntityNode/EntityNode.types';

export type LineageFlowTemporaryNodeData = {
	nodeId: string;
	position: Position;
};

export interface LineageFlowTemporaryNode
	extends Node<LineageFlowTemporaryNodeData> {}

export function isLineageFlowTemporaryNode(
	node: LineageFlowNode | LineageFlowTemporaryNode
): node is LineageFlowTemporaryNode {
	return node.type === 'TEMPORARY';
}
